<template v-if="props.selectedImageState?.photoList">
  <ImageButton :elevate-on-hover="false" :shrink-on-mobile="false" @click.prevent="select(null)" :selected="isSelected(null)">
    <div class="bg-white checkerboard !w-full !h-full"></div>
  </ImageButton>

  <!-- upload background button -->
  <ImageButton :elevate-on-hover="false" :shrink-on-mobile="false" @click="uploadFile">
    <div class="!bg-white !hover:bg-secondary h-full flex justify-center items-center">
      <AddIcon />
    </div>
  </ImageButton>

  <!-- uploaded background -->
  <ImageButton v-if="props.selectedImageState?.uploadedBackgroundPhotoUrl" :elevate-on-hover="false" :small-on-mobile="false" :selected="isSelected(props.selectedImageState?.uploadedBackgroundPhotoUrl)" @click.prevent="select(props.selectedImageState?.uploadedBackgroundPhotoUrl)" :key="props.selectedImageState?.uploadedBackgroundPhotoUrl">
    <Image :src="props.selectedImageState?.uploadedBackgroundPhotoUrl" alt="Uploaded image" img-classes="object-cover !w-16 !h-16 bg-white checkerboard" />
  </ImageButton>

  <!-- original background -->
  <ImageButton :elevate-on-hover="false" :shrink-on-mobile="false" :selected="isSelected(originalUrl(store.selectedImage))" @click.prevent="select(originalUrl(store.selectedImage))" :key="originalUrl(store.selectedImage)">
    <Image :src="originalUrl(store.selectedImage)" alt="Original image" img-classes="object-cover !w-16 !h-16 bg-white checkerboard" />
  </ImageButton>

  <template v-if="props.isLoading">
    <div v-for="i in 16" :key="i" class="!h-16 !w-16 !rounded-lg !bg-secondary animate-pulse"></div>
  </template>

  <ImageButton v-else :elevate-on-hover="false" :shrink-on-mobile="false" v-for="photo in props.availableBackgrounds" :selected="isSelected(photo.image_url)" @click.prevent="select(photo.image_url)" :key="photo.thumbnail_url">
    <Image :src="photo.thumbnail_url" alt="Example image" img-classes="object-cover !w-16 !h-16 bg-white checkerboard" />
  </ImageButton>
</template>

<script setup lang="ts">
import { Image, ImageButton, AddIcon } from "prism";
import { Background, originalUrl } from "@/modules/internal_api/image";
import { useEditorStore } from "@/stores/editor_store";
import { rbgEditorApplyBackgroundImageV100 } from "kaleido-event-tracker";

export interface PhotoTilesProps {
  isLoading: boolean;
  selectedImageState: any;
  availableBackgrounds: Background[];
}
const props = defineProps<PhotoTilesProps>();

const store = useEditorStore();

const select = (image_url) => {
  props.selectedImageState.withSnapshot(() => {
    props.selectedImageState.setSelectedBackgroundColor(undefined);
    props.selectedImageState.setSelectedBackgroundPhotoUrl(image_url);
  });

  rbgEditorApplyBackgroundImageV100({ image_id: store.selectedImage.meta.id, background_image_id: image_url });
};

const isSelected = (image_url) => {
  return props.selectedImageState.selectedBackgroundPhotoUrl === image_url;
};

const uploadFile = () => {
  window.onUploadBackgroundFile();
};
</script>
